import React, { useEffect, useState } from 'react'
import { Container, Badge } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setYear, setMonth, clearMonth, clearFilters, clearResults } from '../../Reducers/filterReducer';
import Alert from 'react-bootstrap/Alert';
import articlePublicationDateService from '../../Services/articlePublicationDateService';
import { useTranslation } from 'react-i18next';
import { Accordion } from "react-bootstrap";
import CloseButton from 'react-bootstrap/CloseButton';
import "./YearsList.css"

const YearsList = () => {
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [show, setShow] = useState(false);
    const [yearsCount, setYearsCount] = useState([]);
    const [newsCount, setNewsCount] = useState("");

    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();

    const channelGuid = useSelector((state) => state.channel.channelGuid);

    useEffect(() => {
        (async () => {
            if (channelGuid) {
                try {
                    const data = await articlePublicationDateService.getYearsCount(channelGuid);
                    setYearsCount(data.years);
                } catch (error) {
                    console.error("Errore nel recupero degli anni:", error);
                }
            }
        })();
    }, [channelGuid]);

    const handleYearClick = (year) => {
        setSelectedYear(year.year);
        setNewsCount(year.count)
        dispatch(clearMonth());
        setSelectedMonth("");
        dispatch(setYear(year.year));
        setShow(true);
    }

    const handleMonthClick = (month, e) => {
        setSelectedMonth(month.month);
        setNewsCount(month.count);
        dispatch(setMonth(month.month));
        setShow(true);
        if (selectedYear === "") {
            const currentYear = e.currentTarget.parentNode.parentNode.parentNode.querySelector(".accordion-header span").textContent;
            setSelectedYear(currentYear);
            dispatch(setYear(currentYear));
        }
    }

    const handleClick = () => {
        setShow(false);
        dispatch(clearFilters());
        dispatch(clearResults());
        setSelectedMonth("");
        setSelectedYear("");
    }

    return (
        <Container fluid className='panel panel-body p-0'>
            <div className="panel-heading mb-0">
                <i className="bi bi-calendar3"></i>
                <span> {t('articles_by_year')}</span>
            </div>
            <Container fluid className='years-list'>
                {show &&
                    <Alert variant="info" className='d-flex flex-row align-items-center'>
                        <p>
                            {newsCount} news on {selectedMonth ? i18n.t(`months.${selectedMonth}`, { lng: "en" }) : ""} {selectedYear}
                        </p>
                        <CloseButton onClick={handleClick} />
                    </Alert>
                }
                <Accordion>
                    {yearsCount.map((year, index) => (
                        <Accordion.Item
                            eventKey={String(index)}
                            key={index}
                            className="mb-2"
                        >
                            <Accordion.Header onClick={() => handleYearClick(year)}>
                                <span>{year.year}</span>
                                <Badge bg="warning">{year.count}</Badge>
                            </Accordion.Header>
                            <Accordion.Body>
                                {year.months.map((month, index) => {
                                    return (
                                        <div key={index} onClick={(e) => handleMonthClick(month, e)} className='month'>
                                            <span>{t(`months.${month.month}`)}</span>
                                            <Badge bg="secondary">{month.count}</Badge>
                                        </div>
                                    )
                                })}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
        </Container>
    )
}

export default YearsList;